const reducer = (count, house) => count + house.people.length;

const guestCount = households => households.reduce(reducer, 0);
export default guestCount;
